import React, { Component } from 'react'
import {
  ListaProdutosParaAtualizarEstoque,
  AtualizarEstoqueProduto,
} from '../../../services/api'
import GridTable from '../../../lib/GridTable'
import { GoDiffRenamed } from 'react-icons/go'
import {
  AtualizarEstoqueContainer,
  AtualizarEstoqueContainerText,
  Content,
  Filter,
  FilterControl,
  ModalContainer,
  ModalContainerContent,
  ModalContainerContentHeader,
  ModalContainerDataGrid,
  ModalContainerDataGridTable,
  ModalContainerFooter,
  Tables,
} from './styles'
import { ThreeDots } from 'react-loading-icons'
import { Input, InputGroup, InputLeftAddon, Text } from '@chakra-ui/react'
import Moment from 'moment'
import Header from '../../../components/Header'

class AtualizarEstoque extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      list_data: [],
      data_modal: null,
      view_modal: false,
      loading: false,
      codigo_usuario: JSON.parse(localStorage.getItem('authentication'))
        .codigo_usuario,
      nome_usuario: JSON.parse(localStorage.getItem('authentication'))
        .nome_usuario,
    }
  }

  listProductToUpdate = async () => {
    this.setState({ data: [] })
    this.setState({ list_data: [] })
    try {
      if (
        this.state.numero_pedido_filter != '' &&
        this.state.numero_pedido_filter != null &&
        this.state.numero_pedido_filter != undefined
      ) {
        var param = { numero_pedido: this.state.numero_pedido_filter }
      } else {
        var param = {}
      }
      const response = await ListaProdutosParaAtualizarEstoque.post('', param)
      var data = response.data

      Object.values(data).map((item) => {})

      this.setState({ data: data })

      var list = []
      Object.values(data).map((item) => {
        list.push({
          quantidade_produto: item.length,
          numero_nota: item[0].numero_nota,
          numero_pedido: item[0].numero_pedido,
          codigo_vendedor: item[0].codigo_vendedor,
          nome_vendedor: item[0].nome_vendedor,
          saida_material: item[0].saida_material,
        })
      })

      this.setState({ list_data: list })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  setModalView = async (e, value) => {
    if (e != null) {
      var data = JSON.parse(e)
      await this.setState({
        data_modal: { numero_pedido: data.numero_pedido },
      })
    }

    this.setState({ view_modal: value })
    if (!value) {
      this.setState({ data: [], list_data: [] })
      this.listProductToUpdate()
    }
  }

  changeField = async (e, value) => {
    var value_field = e.target.value
    var objitem = JSON.parse(e.target.attributes.data.value)

    Object.values(this.state.data).map((item) => {
      if (
        item[0].numero_pedido.trim() ==
        this.state.data_modal.numero_pedido.trim()
      ) {
        item.map((lin) => {
          if (lin.codigo_produto == objitem.codigo_produto) {
            lin[value] = value_field
            lin.updated = true
          }
        })
      }
    })
    this.setState({ uptade: true })
  }

  changeFilter = async (e, value) => {
    this.setState({ [value]: e.target.value })
  }

  confirmarEstoque = async () => {
    try {
      this.setState({ loading_confirmar: true })

      var data_to_update = []
      Object.values(this.state.data).map(async (item) => {
        if (
          item[0].numero_pedido.trim() ==
          this.state.data_modal.numero_pedido.trim()
        ) {
          item.map((lin) => {
            if (lin.nome_fornecedor != undefined) {
              lin.codigo_usuario = this.state.codigo_usuario
              lin.nome_usuario = this.state.nome_usuario
              data_to_update.push(lin)
            }
          })
        }
      })

      data_to_update.map((item) => {
        item.codigo_usuario = this.state.codigo_usuario
        item.nome_usuario = this.state.nome_usuario
      })

      var response = await AtualizarEstoqueProduto.post('', {
        produtos: data_to_update,
      })
      var data = response.data

      if (data.status != 1) {
        alert(data.message)
        return true
      }

      alert('Produtos atualizados')
      this.setState({ loading_confirmar: false })
      this.setModalView(null, false)
    } catch (error) {
      alert('Erro ao atualizar itens.')
      this.setState({ loading_confirmar: false })
      console.log(Object.keys(error), error.message)
    }
  }

  render() {
    function checkFormatter(cell, formatExtraData, exec_function, data) {
      return (
        <div>
          <GoDiffRenamed
            fontSize={20}
            data={data}
            onClick={() => exec_function(data)}
          />
        </div>
      )
    }

    function dataFormatter(value) {
      return Moment(value).format('D/MM/Y')
    }

    const counterNumPed = this.state.list_data.filter((item, index, self) => {
      return (
        index === self.findIndex((t) => t.numero_pedido === item.numero_pedido)
      )
    }).length

    const columns = [
      {
        dataField: 'numero_pedido',
        text: 'Abrir itens',
        formatter: checkFormatter,
        formatExtraData: [],
        exec_function: (e) => this.setModalView(e, true),
        sort: true,
      },
      {
        dataField: 'numero_pedido',
        text: 'Número da proposta',
        sort: true,
      },
      {
        dataField: 'quantidade_produto',
        text: 'Qtd. de itens',
        sort: true,
      },
      {
        dataField: 'nome_vendedor',
        text: 'Vendedor solicitante',
      },
      {
        dataField: 'saida_material',
        text: 'Saida do Material',
        formatter: dataFormatter,
      },
    ]

    return (
      <>
        <AtualizarEstoqueContainer>
          <AtualizarEstoqueContainerText>
            <h1>
              ATUALIZAR <strong>ESTOQUE</strong>
            </h1>
          </AtualizarEstoqueContainerText>
          {this.state.view_modal ? (
            <Modal
              closeModalLayout={() => this.setModalView(null, false)}
              data_modal={this.state.data}
              numero_pedido={this.state.data_modal.numero_pedido}
              confirmarEstoque={this.confirmarEstoque}
              changeField={this.changeField}
              loading={this.state.loading}
              loading_confirmar={this.state.loading_confirmar}
            />
          ) : (
            <></>
          )}
          <Filter>
            <FilterControl>
              <InputGroup w="370px">
                <InputLeftAddon
                  bgColor="#9a649e"
                  color="white"
                  children="Nº PEDIDOS:"
                />
                <Input
                  focusBorderColor="#9a649e"
                  bgColor="white"
                  autoFocus
                  placeholder="Digite o número..."
                  name="numero_proposta"
                  type="text"
                  onChange={(e) => this.changeFilter(e, 'numero_pedido_filter')}
                />
              </InputGroup>
              <button onClick={() => this.listProductToUpdate()}>
                Filtrar
              </button>
            </FilterControl>
            {this.state.list_data.length == 0 ? (
              <h1>Nenhuma solicitação de estoque encontrada.</h1>
            ) : (
              <></>
            )}
          </Filter>

          <Content>
            {this.state.list_data.length > 0 && (
              <Text
                fontSize="1.2rem"
                fontWeight="bold"
                color="#606163"
                marginLeft={'1rem'}
                textAlign={'center'}
              >
                {counterNumPed} Pedidos
              </Text>
            )}
            <Tables>
              {this.state.list_data.length > 0 ? (
                <GridTable columns={columns} dados={this.state.list_data} />
              ) : (
                <></>
              )}
            </Tables>
          </Content>
        </AtualizarEstoqueContainer>
      </>
    )
  }
}

function Modal(data) {
  console.log('data modal', data)
  return (
    <ModalContainer>
      <ModalContainerContent>
        <ModalContainerContentHeader>
          <p>ITENS PARA CONFIRMAÇÃO DE ESTOQUE</p>
          <span onClick={() => data.closeModalLayout()}>Fechar</span>
        </ModalContainerContentHeader>
        <ModalContainerDataGrid>
          <ModalContainerDataGridTable>
            <table>
              <thead>
                <th>Código do Produto</th>
                <th>Valor do produto</th>
                <th>Cor</th>
                <th>Prazo</th>
                <th>Qtd. Negociada</th>
                <th>Estoque</th>
                <th>Codigo do Produto (Fornecedor)</th>
                <th>Fornecedor</th>
                <th>Link</th>
              </thead>
              <tbody>
                {data.loading_grid ? (
                  <ThreeDots color="black" />
                ) : (
                  Object.values(data.data_modal).map((item) => {
                    if (
                      parseInt(item[0].numero_pedido.trim()) ===
                      parseInt(data.numero_pedido.trim())
                    ) {
                      console.log('true', item)
                      return item.map((lin) => {
                        if (lin.nome_fornecedor != undefined) {
                          return (
                            <tr>
                              <td>{lin.codigo_produto}</td>
                              <td>
                                <div>
                                  <label>R$</label>
                                  <input
                                    type="number"
                                    step="0.01"
                                    data={JSON.stringify(lin)}
                                    value={parseFloat(lin.valor_fornecedor)}
                                    onChange={(e) =>
                                      data.changeField(e, 'valor_fornecedor')
                                    }
                                  />
                                </div>

                                {/* {parseFloat(lin.valor_fornecedor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} */}
                              </td>
                              <td>{lin.descricao_cor}</td>
                              <td>{lin.prazo_de_entrega}</td>
                              <td>{parseInt(lin.quantidade_negociada)}</td>
                              <td>
                                <div>
                                  <input
                                    type="number"
                                    step="0.01"
                                    data={JSON.stringify(lin)}
                                    value={parseInt(lin.quantidade_estoque)}
                                    onChange={(e) =>
                                      data.changeField(e, 'quantidade_estoque')
                                    }
                                  />
                                </div>

                                {/* {parseInt(lin.quantidade_estoque)} */}
                              </td>
                              <td>{lin.codigo_produto_fornecedor}</td>
                              <td>
                                {lin.nome_fornecedor.trim().length <= 22
                                  ? lin.nome_fornecedor.trim()
                                  : lin.nome_fornecedor.trim().substr(0, 22) +
                                    '...'}
                                sem fornecedor
                              </td>
                              {lin.link_para_produto != '' &&
                              lin.link_para_produto != null ? (
                                <td>
                                  <a href={lin.link_para_produto}>Acessar</a>
                                </td>
                              ) : (
                                <></>
                              )}
                            </tr>
                          )
                        }
                      })
                    }
                  })
                )}
              </tbody>
            </table>
            <ModalContainerFooter>
              <button onClick={() => data.confirmarEstoque()}>
                {data.loading_confirmar ? <ThreeDots /> : 'Salvar Alterações'}
              </button>
            </ModalContainerFooter>
          </ModalContainerDataGridTable>
        </ModalContainerDataGrid>
      </ModalContainerContent>
    </ModalContainer>
  )
}

export default AtualizarEstoque
